export const PROP_TO_PARAM_MAP = {
  uuid: "uuid",
  keywords: "keywords",
  languages: "languages",
  sources: "sources",
  tags: "tags",
  nearKeywords: "near_keywords",
  nearDistance: "near_distance",
  nearNearKeywords: "near_near_keywords",
  notNearKeywords: "not_near_keywords",
  notNearDistance: "not_near_distance",
  includeChannelNames: "include_channel_names",
  excludeChannelNames: "exclude_channel_names",
  minReachByChannelType: "min_reach_by_channel_type",
  excludeTopics: "exclude_topics",
  mentionTypes: "mention_types",
  includePaywalled: "include_paywalled",
} as const;

export type FilterKey = keyof typeof PROP_TO_PARAM_MAP;
export type SnakeKey = (typeof PROP_TO_PARAM_MAP)[FilterKey];

export type QueryIn = {
  uuid?: string | null;
  keywords?: string[];
  languages?: string[];
  sources?: string[];
  tags?: string[];
  nearKeywords?: string[];
  nearDistance?: number;
  nearNearKeywords?: string[];
  notNearKeywords?: string[];
  notNearDistance?: number;
  includeChannelNames?: Array<string | null | undefined>;
  excludeChannelNames?: Array<string | null | undefined>;
  minReachByChannelType?:
    | (Record<string, number> & { has_custom_values?: boolean })
    | { no_values: true };
  excludeTopics?: string[];
  mentionTypes?: string[];
  includePaywalled?: boolean;
};

type CamelToSnake<T extends object> = {
  [K in keyof T as K extends FilterKey
    ? (typeof PROP_TO_PARAM_MAP)[K]
    : never]?: T[K];
};

export type QueryOut = CamelToSnake<QueryIn>;

export const prepareQuery = (query: Partial<QueryIn>): QueryOut => {
  const out = {} as QueryOut;

  (Object.entries(PROP_TO_PARAM_MAP) as Array<[FilterKey, SnakeKey]>).forEach(
    ([camel, snake]) => {
      const v = query[camel];
      if (v !== undefined && v !== null && v !== "") {
        // @ts-expect-error - index remapping handled in type CamelToSnake
        out[snake] = v;
      }
    }
  );

  const exclude = (query.excludeChannelNames ?? []).filter(Boolean) as string[];
  const include = (query.includeChannelNames ?? []).filter(Boolean) as string[];

  out[PROP_TO_PARAM_MAP.excludeChannelNames] = exclude;
  out[PROP_TO_PARAM_MAP.includeChannelNames] = include;

  return out;
};
